(() => {
  const qs = (s, r = document) => r.querySelector(s);
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));

  const drawer = qs('[data-atiba-drawer]');
  const openBtn = qs('[data-atiba-cart-open]');
  const closeBtn = qs('[data-atiba-cart-close]');
  const itemsEl = qs('[data-atiba-cart-items]');
  const countEl = qs('[data-atiba-cart-count]');
  const subtotalEl = qs('[data-atiba-subtotal]');

  const mobile = qs('[data-atiba-mobile]');
  const menuOpen = qs('[data-atiba-menu-open]');

  function money(cents) {
    const n = (cents || 0) / 100;
    const currency = window.Shopify?.currency?.active || 'USD';
    return n.toLocaleString(undefined, { style: 'currency', currency });
  }

  function setDrawer(open) {
    if (!drawer) return;
    drawer.hidden = !open;
    document.documentElement.style.overflow = open ? 'hidden' : '';
  }

  async function getCart() {
    const res = await fetch('/cart.js', { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Cart fetch failed');
    return res.json();
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll('&', '&amp;')
      .replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;')
      .replaceAll('"', '&quot;')
      .replaceAll("'", '&#039;');
  }

  function renderCart(cart) {
    const totalItems = (cart.items || []).reduce((s, it) => s + (it.quantity || 0), 0);
    if (countEl) countEl.textContent = String(totalItems);
    if (subtotalEl) subtotalEl.textContent = money(cart.total_price);

    if (!itemsEl) return;

    if (!cart.items || cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="atiba-note">Your cart is empty. Add something that smells like destiny.</div>';
      return;
    }

    itemsEl.innerHTML = cart.items
      .map((it) => {
        const title = it.product_title || it.title || 'Item';
        const variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        const line = money(it.line_price);
        return `
          <div class="atiba-item">
            <div>
              <div class="t">${escapeHtml(title)}</div>
              <div class="s">Qty: ${it.quantity}${variant ? ' • ' + escapeHtml(variant) : ''}</div>
              <div class="s">${line}</div>
            </div>
            <div class="r">
              <button class="atiba-rm" type="button" data-atiba-remove data-line="${it.key}" aria-label="Remove">✕</button>
            </div>
          </div>
        `;
      })
      .join('');

    qsa('[data-atiba-remove]', itemsEl).forEach((btn) => {
      btn.addEventListener('click', async () => {
        const key = btn.getAttribute('data-line');
        if (!key) return;
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 }),
          credentials: 'same-origin',
        });
        const cart2 = await getCart();
        renderCart(cart2);
      });
    });
  }

  async function openCart() {
    setDrawer(true);
    try {
      const cart = await getCart();
      renderCart(cart);
    } catch (e) {
      if (itemsEl) itemsEl.innerHTML = '<div class="atiba-note">Couldn\'t load cart. Refresh and try again.</div>';
    }
  }

  if (openBtn) openBtn.addEventListener('click', openCart);
  if (closeBtn) closeBtn.addEventListener('click', () => setDrawer(false));
  if (drawer) drawer.addEventListener('click', (e) => {
    if (e.target === drawer) setDrawer(false);
  });
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setDrawer(false);
  });

  // Mobile menu toggle
  if (menuOpen && mobile) {
    menuOpen.addEventListener('click', () => {
      const isOpen = mobile.style.display === 'block';
      mobile.style.display = isOpen ? 'none' : 'block';
    });
  }

  // Add to cart buttons
  qsa('[data-atiba-add]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      const id = btn.getAttribute('data-variant-id');
      if (!id) return;
      btn.setAttribute('disabled', 'disabled');
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] }),
          credentials: 'same-origin',
        });
        await openCart();
      } catch (e) {
        alert('Could not add to cart. Please try again.');
      } finally {
        btn.removeAttribute('disabled');
      }
    });
  });

  // Initialize cart count on load
  (async () => {
    try {
      const cart = await getCart();
      const totalItems = (cart.items || []).reduce((s, it) => s + (it.quantity || 0), 0);
      if (countEl) countEl.textContent = String(totalItems);
    } catch (_) {}
  })();
})();
